import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import AddAssetForm from "./AddAssetForm";
import UpdateMacIdsForm from "./UpdateMacIdsForm";
import AddLocationForm from "./AddLocation";
import AddGatewayForm from "./AddGatewayForm";
import AddCategoryForm from "./AddCategoryForm";
import AddBeacons from "./AddBeacons";
import UpdateAlert from "./UpdateAlert";
function SettingsPage() {
  return (
    <Grid container spacing={2}>

      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant={"h7"} noWrap style={{ color: "#07689f", fontFamily: 'sans-serif', fontSize: 24 }}>
              Location
            </Typography>
            <AddLocationForm />
          </Grid>
          <Grid item xs={12} style={{ color: "#07689f", fontFamily: 'sans-serif', fontSize: 24 }}>
            <Typography variant={"h6"} noWrap>
              Gateway
            </Typography>
            <AddGatewayForm />
          </Grid>
          <Grid item xs={12}>
            <Typography variant={"h6"} noWrap style={{ color: "#07689f", fontFamily: 'sans-serif', fontSize: 24 }}>
              Category
            </Typography>
            <AddCategoryForm />
          </Grid>
          <Grid item xs={12} style={{ marginTop: 22 }}>
            <Typography variant={"h6"} noWrap style={{ color: "#07689f", fontFamily: 'sans-serif', fontSize: 24 }}>
              Assets
            </Typography>
            <AddBeacons />
            <AddAssetForm />
          </Grid>
          <Grid item xs={12} style={{ marginTop: 22 }}>
            <Typography variant={"h6"} noWrap style={{ color: "#07689f", fontFamily: 'sans-serif', fontSize: 24 }}>
              Alerts
            </Typography>
            <UpdateAlert />
          </Grid>

        </Grid>
      </Grid>
    </Grid>
  );
}

export default SettingsPage;
